import { render, staticRenderFns } from "./SnackbarProvider.vue?vue&type=template&id=5194c49f"
import script from "./SnackbarProvider.vue?vue&type=script&lang=ts"
export * from "./SnackbarProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports